import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import config from '../../config';
import loadDataSources from '../../action/loadDataSources';
import { loadAction } from '../../util/decorators';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import VideoList from './VideoList.jsx';
import translateRouteParams from '../../util/translateRouteParams.js';
import Article from 'component/ArticleFeed/Article';

const VIDEOS_PER_REQUEST = 50;

const $loadPromoDataSources = args => {
  if (args.routeParams.sports) {
    return null;
  }

  const slug = _.get(config, `VIDEO_ARTICLE_${args.country.toUpperCase()}`);
  return slug ? loadDataSources({
    dataSourceConfigs: {
      videoArticle: 'articleBySlug',
    },
    country: args.counrtry,
    routeParams: {
      slug,
    },
  }) : null;
};

const $loadVideoDataSources = (args, dispatchResult) => {
  if (!_.isEmpty(_.get(dispatchResult, 'payload.videoArticle[0]'))) {
    return null;
  }
  const mappedParams = translateRouteParams(args.routeParams, args.country);
  return loadDataSources({
    dataSourceConfigs: {
      videosWithEvent: 'videosWithEvent',
    },
    limit: {
      videosWithEvent: VIDEOS_PER_REQUEST,
    },
    ...args,
    routeParams: mappedParams.include,
    excludeParams: mappedParams.exclude,
  });
};

const mapStateToProps = state => ({
  country: state.country,
  language: state.language,
  videos: _.get(state, 'dataSources.videosWithEvent'),
  article: _.get(state, 'dataSources.videoArticle[0]'),
  routeParams: state.routeParams,
});

const mapDispatchToProps = (dispatch) => ({
  loadMoreData: (routeParams, country, offset, language) => {
    return dispatch($loadVideoDataSources({
      offset: {
        videosWithEvent: offset,
      },
      country: country,
      routeParams: routeParams,
      language: language,
    }));
  },
});

@loadAction($loadPromoDataSources, $loadVideoDataSources)
@connect(mapStateToProps, mapDispatchToProps)
@linkTag2Initializer('video-page')
export default class VideoPage extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { videos, routeParams, country, language, loadMoreData, article } = this.props;
    return (
      <PageWithSidebars>
        {!_.isEmpty(article) && <Article article={article} firstArticle autoplay inline />}
        {!_.isEmpty(videos) && <VideoList
          country={country}
          language={language}
          videos={videos}
          videosPerRequest={VIDEOS_PER_REQUEST}
          routeParams={routeParams}
          loadMoreData={loadMoreData}
        />}
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Video/VideoPage.jsx